<!--
 * @Author       : Tom
 * @Date         : 2019-12-22 14:21:54
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 19:22:23
 * @FilePath     : /shop_front_end/src/views/goods_manage/issue.vue
 * @Description  : 商品管理-编辑商品
 -->
<template>
  <div class="goods-add">
    <a-card :bordered="false">
      <a-card title="基本信息" :bordered="false">
        <a-form class="boxs" :form="form">
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="8">
					<a-form-item label="商品标题" >
					  <a-input v-model="pro_title" v-decorator="['pro_title', { rules: [{ required: true, message: '请输入商品标题' }] , initialValue: pro_title}]" placeholder="请输入商品标题"/>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="副标题">
					  <a-input v-model="pro_title1" placeholder="请输入商品描述"/>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="关键字">
					  <a-input v-model="pro_keys" v-decorator="['pro_keys', { rules: [{ required: true, message: '请输入商品关键词' }] , initialValue: pro_keys}]" placeholder="请输入商品关键词"/>
					</a-form-item>
				</a-col>
			</a-row>
			
			
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="8">
					<a-form-item label="商品类别">
					  <a-cascader
					    v-if="options.length"
					    :fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
					    :options="options"
					    @change="onChange"
					    :displayRender="displayRender"
					    changeOnSelect
					    :loadData="loadData"
					    placeholder="请选择商品分类"
						v-decorator="['classify', { rules: [{ required: true, message: '请选择商品分类' }] , initialValue: defaultValue}]"
					  />
					  <a-select v-else placeholder="请选择商品分类"></a-select>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="商品品牌">
					  <a-select allowClear placeholder="请选择商品品牌" v-model="pro_brand"
					            v-decorator="['pro_brand', { rules: [{ required: true, message: '请选择商品品牌' }] , initialValue: pro_brand}]">
					    <a-select-option
					            v-for="(item,i) in brandlist"
					            :key="i"
					            :value="item.brand_id"
					    >{{ item.brand_name }}</a-select-option>
					  </a-select>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="重量">
					  <a-input  type="number" v-model="weight" v-decorator="['weight', { rules: [{ required: true, message: '请输入商品关键词' }] , initialValue: weight}]" placeholder="请输入重量(kg)" />
					
					</a-form-item>
				</a-col>
			</a-row>
			
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="8">
					<a-form-item label="商品封面图">
					  <div class="clearfix">
					    <a-upload
								:show-upload-list="{showPreviewIcon: false}"
					            :action="downloadURL"
					            :fileList="fileList2"
					            listType="picture-card"
					            @change="handleChange2"
					            :headers="heads"
					            v-decorator="['downloadURL', { rules: [{ required: true, message: 'Please input your note!' }]}]"
					    >
					      <div v-if="!cover_map">
					        <a-icon type="plus" />
					        <div class="ant-upload-text">上传图片</div>
					      </div>
					    </a-upload>
					  </div>
					</a-form-item>
				</a-col>
				<a-col :span="16">
					<a-form-item label="商品展示图">
					  <div class="clearfix">
					    <a-upload
						  :show-upload-list="{showPreviewIcon: false}"
					      :action="downloadURL"
					      :fileList="fileList"
					      listType="picture-card"
					      @change="handleChange"
					      :headers="heads"
									v-decorator="['downloadURL', { rules: [{ required: true, message: 'Please input your note!' }]}]"
					    >
					      <div v-if="imgurls.length < 5">
					        <a-icon type="plus" />
					        <div class="ant-upload-text">上传图片</div>
					      </div>
					    </a-upload>
					
					    <div
					      v-for="(item,index) in imgurls"
					      :key="index"
					      :class="'setMap'+index"
					      @click="setMap(index)"
					    >{{index==0?'主图':'设为主图'}}</div>
					
					    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
					      <img alt="example" style="width: 100%" :src="previewImage" />
					    </a-modal>
					  </div>
					</a-form-item>
				</a-col>
			</a-row>
			
        </a-form>
      </a-card>
	  <div style="height: 20px;background-color: #f0f2f5;"></div>
      <a-card title="商品属性" :bordered="false">
        <a-form class="boxs" :form="form1">
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="8">
					<a-form-item label="经销商价">
					  <a-input type="number" min="0" v-model="price_cbj" v-decorator="['price_cbj', { rules: [{ required: true, message: '请设置商品的默认经销商价' }], initialValue: price_cbj }]" placeholder="请设置商品的默认经销商价"/>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="原价">
					  <a-input type="number" min="0" v-model="price_yj" v-decorator="['price_yj', { rules: [{ required: true, message: '请设置商品的默认原价' }], initialValue: price_yj }]" placeholder="请设置商品的默认原价"/>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="终端价">
					  <a-input type="number" min="0" v-model="price_sj" v-decorator="['price_sj', { rules: [{ required: true, message: '请设置商品的默认终端价' }], initialValue: price_sj }]" placeholder="请设置商品的默认终端价"/>
					</a-form-item>
				</a-col>
			</a-row>
			
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="8">
					<a-form-item label="单位">
					  <a-select allowClear v-model="unit" @change="handleSelectChange" placeholder="请选择单位">
					    <a-select-option
					      v-for="(item,index) in unitList"
					      :key="index"
					      :value="item.name"
					    >{{item.name}}</a-select-option>
					  </a-select>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="库存">
					  <a-input type="number" min="0" v-model="kucun" v-decorator="['kucun', { rules: [{ required: true, message: '请设置商品的默认库存' }], initialValue: kucun }]" placeholder="请设置商品的默认库存"/>
					</a-form-item>
				</a-col>
				
				<a-col :span="8">
					<a-form-item label="虚拟销量">
					  <a-input type="number" min="0" v-model="volume" v-decorator="['volume', { rules: [{ required: false, message: '请设置虚拟销量' }], initialValue: volume }]" placeholder="请设置商品的默认库存"/>
					</a-form-item>
				</a-col>
			</a-row>
            
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="24">
					<a-form-item label="产品规格">
					  <div>
					    <!-- <a-button type="primary" @click="visible=true">选择商品规格</a-button>
					    <a-divider type="vertical" />
					    <a-button @click="visibleB=true">自定义商品规格</a-button> -->
						<a-button id="addAttribute" type="primary">添加属性</a-button>
					  </div>
					
					  <div>
					    <a-table :columns="columns" :dataSource="tableData" :row-key="record => record.ind" :pagination="false">
					      <template slot="cbj" slot-scope="text,record">
					        <a-input type="number" min="0" v-model="record.cbj" />
					      </template>
					      <template slot="yj" slot-scope="text,record">
					        <a-input type="number" min="0" v-model="record.yj" />
					      </template>
					      <template slot="sj" slot-scope="text,record">
					        <a-input type="number" min="0" v-model="record.sj" />
					      </template>
					      <template slot="kucun" slot-scope="text,record">
					        <a-input type="number" min="0" v-model="record.kucun" />
					      </template>
					      <template slot="bar_code" slot-scope="text,record">
					        <a-input v-model="record.bar_code" />
					      </template>
					
					      <template slot="image" slot-scope="text,record,index">
					        <a-upload
							 :show-upload-list="{showPreviewIcon: false}"
					          v-if="!tableList[index].image"
					          :action="downloadURL"
					          listType="picture-card"
					          @change="changeAttrImg($event,record,index)"
					          :headers="heads"
					        >
					          <div v-if="!tableList[index].image">
					            <a-icon type="plus" />
					            <div class="ant-upload-text">Upload</div>
					          </div>
					        </a-upload>
					        <div v-else class="imgssds">
					          <img :src="tableList[index].image" style="width:100px;height:100px;" />
					
					          <a-icon class="close" @click="onCloses(index)" type="close" />
					        </div>
					      </template>
					
					      <template slot="act" slot-scope="text,record,index">
					        <a-button type="primary" @click="onDelele(index)">删除</a-button>
					      </template>
					    </a-table>
					  </div>
					</a-form-item>
				</a-col>
			</a-row>
			
        </a-form>
      </a-card>
		<div style="height: 20px;background-color: #f0f2f5;"></div>
      <a-card title="商品设置" :bordered="false">
		  
        <a-form class="boxs" :form="form2">
			
			<a-row :gutter="80" style="padding: 0 20px;">
				<a-col :span="8">
					<a-form-item label="库存预警">
					  <a-input type="number" min="0" v-model="warning" v-decorator="['warning', { rules: [{ required: true, message: '请设置库存预警值' }], initialValue: warning }]" placeholder="请设置库存预警值"></a-input>
					</a-form-item>
				</a-col>
				<a-col :span="8" v-if="commodity_type == 0">
					<a-form-item label="运费设置">
					  <a-select allowClear v-model="freight" v-decorator="['freight', { rules: [{ required: true, message: '请选择运费模板' }], initialValue: freight }]" placeholder="请选择运费模板">
					    <a-select-option v-for="(item,index) in freightList" :key="index" :value="item.id">{{item.name}}</a-select-option>
					  </a-select>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="商品标签">
					  <a-checkbox v-for="item,index of s_type" :key="index" v-model="setTag[index]" :value="item.value">{{item.name}}</a-checkbox>
					</a-form-item>
				</a-col>
				<a-col :span="8" v-if="commodity_type == 0">
					<a-form-item label="支持活动类型">
					  <a-radio-group :options="plainOptions" v-model="act_type" :defaultValue="act_type" @change="handleAct" />
					</a-form-item>
				</a-col>
				<a-col :span="16" v-if="commodity_type == 0">
					<a-form-item v-if="dp_show" label="显示位置">
					  <a-checkbox v-for="item,index of show_adr" :key="index" v-model="display_position[index]" :value="item.value">{{item.name}}</a-checkbox>
					</a-form-item>
				</a-col>
			</a-row>
			
        </a-form>
      </a-card>
<div style="height: 20px;background-color: #f0f2f5;"></div>
      <a-card title="详细内容" :bordered="false">
        <a-row :gutter="80" style="padding: 0 20px;">
        	<a-col :span="13">
        		<a-form class="boxs" style="height:700px;">
        		  <a-form-item label="商品详情">
        		    <UEditor ref="ue"/>
        		  </a-form-item>
        		</a-form>
        	</a-col>
        </a-row>
      </a-card>

      <div class="foot">
        <a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
        <a-button type="primary" @click="onSave">保存</a-button>
      </div>
    </a-card>

    <a-modal title="选择商品规格" v-model="visible" class="modals" width="680px" @ok="chooseAttrOk">
      <a-form>
        <a-form-item label="请选择属性名称:" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select
            mode="multiple"
            v-model="chooseAttrOption"
            style="width: 100%"
            @change="handleChangeValue"
            placeholder="请选择属性名称"
          >
            <a-select-option v-for="(item) in attrList" :key="item.name">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <template v-for="(item,index) in attrList">
          <a-form-item :key="index" v-if="item.status">
            <a-tag closable @close="delChooseName(item)">{{item.name}}</a-tag>
            <div>
              <a-checkbox
                v-for="(items,indx) in item.children"
                :key="indx"
                @change="chooseChange($event,items)"
                v-model="items.status"
              >{{items.name}}</a-checkbox>
            </div>
          </a-form-item>
        </template>
      </a-form>
    </a-modal>

    <a-modal
      title="自定义商品规格"
      v-model="visibleB"
      :zIndex="999"
      class="modals"
      width="680px"
      @ok="addAttrOk"
    >
      <a-form>
        <a-form-item label="属性名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
          <div class="boxs">
            <a-input style="width:310px;" v-model="addAttrName"></a-input>
            <a-button @click="addNature()">添加属性</a-button>
          </div>
        </a-form-item>

        <a-form-item
          v-for="(item,index) in attrAdd"
          :label="item.attr_group_name"
          :key="index"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
        >
          <div class="boxs">
            <a-input style="width:212px;" v-model="item.attrValue"></a-input>
            <a-button @click="addNatureVal(item)">添加属性值</a-button>
            <a-button @click="delAttrName(index)">删除属性</a-button>
          </div>

          <div>
            <a-tag
              v-for="(items,indx) in item.attr_list"
              :key="indx"
              closable
              @close="delAttrValue(index,indx)"
            >{{items.attr_name}}</a-tag>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
	
	<div id="strArr" v-html="strArr1" style="display:none;"></div>
  </div>
</template>

<script>
import UEditor from "../../components/UEditor";
import { downloadURL } from "../../lib/config";
import { getToken } from "../../lib/tool";
import $ from 'jquery'

const columns = [
  {
    title: "经销商价",
    dataIndex: "cbj",
    key: "cbj",
    scopedSlots: { customRender: "cbj" }
  },
  {
    title: "原价",
    dataIndex: "yj",
    key: "yj",
    scopedSlots: { customRender: "yj" }
  },
  {
    title: "终端价",
    dataIndex: "sj",
    key: "sj",
    scopedSlots: { customRender: "sj" }
  },
  {
    title: "库存",
    dataIndex: "kucun",
    key: "kucun",
    scopedSlots: { customRender: "kucun" }
  },
  {
    title: "单位",
    dataIndex: "unit",
    key: "unit"
  },
  {
    title: "条形码",
    dataIndex: "bar_code",
    key: "bar_code",
    scopedSlots: { customRender: "bar_code" }
  },
  {
    title: "上传图片",
    dataIndex: "image",
    key: "image",
    scopedSlots: { customRender: "image" }
  },
  {
    title: "操作",
    key: "act",
    scopedSlots: { customRender: "act" }
  }
];
export default {
  data() {
    return {
      dp_show: false,  //前端显示位置是否显示
	form: this.$form.createForm(this, { name: 'form_in_modal' }),
	form1: this.$form.createForm(this, { name: 'form_in_modal1' }),
	form2: this.$form.createForm(this, { name: 'form_in_modal2' }),
      columns,
      downloadURL,
      plainOptionsb: [
        { label: "是", value: "1" },
        { label: "否", value: "0" }
      ],
      plainOptions: [
        { label: "正价", value: "1" },
        // { label: "分销", value: "5" },
        // { label: "拼团", value: "2" },
        // { label: "砍价", value: "3" },
        // { label: "竞拍", value: "4" },
        { label: "会员", value: "6" },
        // { label: "积分", value: "7" }
      ],
      unitList: [],
      options: [],
      freightList: [],
      brandlist: [],
      visible: false,
      visibleB: false,
      previewVisible: false,
      previewImage: "",
      goodsstyle: {
        height: "600px"
      },
      pro_title: "", //商品标题
      pro_title1: "", //商品副标题
      pro_keys: "", //关键字
      weight: '', //商品重量
      weight_unit: "g", //商品重量单位
      product_number: "L18-K002-T732",
      pro_class: "", //商品分类
      pro_brand: undefined, //商品品牌
      imgurls: [], //商品展示图
      fileList: [], //商品展示图前端展示
      fileList2: [], //商品封面图前端展示
      cover_map: '', // 商品封面图
      price_cbj: "", //经销商价
      price_yj: "", //原价
      price_sj: "", //终端价
      kucun: "", //库存
      unit: "", //单位
      addAttrName: "", //自定义属性名
      attrAdd: [], //自定义属性数据
      attrTitle: [], //返回给后台的属性标题
      tableList: [], //返回给后台的属性数据
      tableData: [], //展示在表格中的数据
      warning: "", //库存预警
      freight: "", //运费
      setTag: [], //设置标签
      act_type: "正价", //活动类型
      display_position: [],
      is_offline: "", //是否线下核销
      content: "",
      attrList: [], //可选择的属性
      chooseAttrOption: [], //选中的属性名
      heads: {},
	  volume:0,
      isHidel: true,
      cache: {},
      defaultValue:[],
      activekey: '',
      pro_id: '',
      brand_id: '',
       s_type: [],
      show_adr: [],
	  
	  watchFlag: false,
	  strArr: [],
	  strArr1: [],
	  commodity_type: ''
    };
  },
  mounted() {
	  this.commodity_type = this.$route.query.commodity_type;
    let content = document.querySelectorAll(".ant-layout-content")[0]
      .offsetHeight;

    this.goodsstyle = {
      height: content + "px"
    };

    let token = getToken("token");
    this.heads = {
      Authorizations: "Bearer " + token
    };

    this.getCommodityClass();
    this.activekey = this.$route.query.tab
    var pro_id = this.$route.params.id;
    this.pro_id = this.$route.params.id;

    this.$request
      .get("?module=pc_api&action=product&app=edit_product_page&id=" + pro_id)
      .then(res => {
        if (res.code == 200) {
          //

          var attrTitle = this.attrTitle;
          this.$request
            .get(
              "?module=pc_api&action=product&app=get_attribute_name&strArr=" +
                attrTitle
            )
            .then(async resb => {
              if (resb.code == 200) {
                this.pro_title = res.product_title;
                this.pro_title1 = res.subtitle;
                this.pro_keys = res.keyword;
                this.weight = res.weight;
				this.volume = res.volume;
				if(res.weight_unit){
					this.weight_unit = res.weight_unit;
				}
				
				this.strArr = res.strArr
				this.strArr1 = res.strArr
                
                this.pro_brand = res.brand_id
                this.brand_id = res.brand_id
                this.brandlist = res.brand_class
                this.pro_class = res.class_id
                for(let itemsa of res.ctypes){
                  this.defaultValue.push(itemsa.cid)
                  await this.httpGetClass({ cid: itemsa.cid })
                }
				
				this.imgurls = []
				for(let i = 0;i<res.imgurls.length;i++){
					if(res.imgurls[i].product_url == ""){
						res.imgurls.splice(i,1)
						i--
					}else{
						this.imgurls.push(res.imgurls[i].product_url)
					}
				}

				if(this.imgurls.length>5){
					this.imgurls.length = 5;
				}
				
                let i = 0;

				this.cover_map = res.cover_map;
                this.fileList2 = [
                  {
                    uid: 1,
                    name: 'xxxx.png',
                    status: "done",
                    url: res.cover_map
                  }
                ];

                this.fileList = Array.from(res.imgurls, item => {
                  return {
                    uid: i++,
                    name: "xxx.png",
                    status: "done",
                    is_center: item.is_center,
                    url: item.product_url
                  };
                });
				
				if(this.fileList.length>5){
					this.fileList.length = 5;
				}
                
                for (let item of res.unit) {
                  if (item.checked) {
                    this.unit = item.name;
                  }
                }

                for (let item of res.freight_list) {
                  if (item.selected) {
                    this.freight = item.id;
                  }
                }

                if(res.sp_type){
                  if(Object.prototype.toString.call(res.sp_type) === '[object Object]'){
                    this.setTag = []

                    res.sp_type = Object.values(res.sp_type)
                    this.s_type = res.sp_type

                    res.sp_type.filter(item=>{
                      this.setTag.push(item.status)
                    })
                  }else{
                    this.s_type = res.sp_type
                    this.setTag = []

                    res.sp_type.filter(item=>{
                      this.setTag.push(item.status)
                    })
                  }
                }
                if(res.show_adr){
                  if(Object.prototype.toString.call(res.show_adr) === '[object Object]'){
                    this.display_position = []

                    res.show_adr = Object.values(res.show_adr)
                    this.show_adr = res.show_adr

                    res.show_adr.filter(item=>{
                      this.display_position.push(item.status)
                    })
                  }else{
                    this.show_adr = res.show_adr
                    this.display_position = []

                    res.show_adr.filter(item=>{
                      this.display_position.push(item.status)
                    })
                  }
                }

        
    
                for (let item of JSON.parse(res.attr_group_list)) {
                  for (let items of resb.list.attribute) {
                    if (item.attr_group_name === items.name) {
                      this.chooseAttrOption.push(items.name);
                      items.status = true;
                      for (let itemb of item.attr_list) {
                        for (let itemc of items.children) {
                          if (itemb.attr_name === itemc.name) {
                            itemc.status = true;
                          }
                        }
                      }
                    }
                  }
                }

                Object.assign(this, {
                  price_cbj: res.initial.cbj,
                  price_yj: res.initial.yj,
                  price_sj: res.initial.sj,
                  kucun: res.initial.kucun,

                  unitList: res.unit,
                  warning: res.min_inventory,
                  freightList: res.freight_list,
                  act_type: res.active,
                  is_offline: res.is_hexiao,
                  attrList: resb.list.attribute,
                  tableList: JSON.parse(res.checked_attr_list)
                });
                if(this.act_type == 6){
                  this.dp_show = false
                }else {
                  this.dp_show = true
                }

                // for (let item of res.show_adr) {
                //   this.display_position[item] = true;
                // }

                // for (let item of res.sp_type) {
                //   this.setTag[item-1] = true;
                // }

                this.$refs.ue.loadEditor(res.content);
				
                if (this.tableList.length) {
					
					let tableList = JSON.parse(JSON.stringify(this.tableList))
					
                  this.chooseAttrOk();
				  
				  let checked_attr_list = JSON.parse(res.checked_attr_list)
				  
				  let tableData = []
				  
				  tableList.filter(item=>{
					  let obj = JSON.parse(JSON.stringify(item))
					  
					  obj.attr_list.filter(it=>{
						  obj[it.attr_group_name] = it.attr_name
					  })
					  
					  tableData.push(obj)
				  })
				  
				  checked_attr_list.filter((item,index)=>{
					  tableData[index].cbj = item.cbj
					  tableData[index].yj = item.yj
					  tableData[index].sj = item.sj
					  tableData[index].kucun = item.kucun
					  tableData[index].bar_code = item.bar_code
					  
					  tableList[index].cbj = item.cbj
					  tableList[index].yj = item.yj
					  tableList[index].sj = item.sj
					  tableList[index].kucun = item.kucun
					  tableList[index].bar_code = item.bar_code
					  tableList[index].image = item.img
				  })
				  
				  this.tableData = tableData
				  this.tableList = tableList
				  
				  
				  setTimeout(()=>{
					  this.watchFlag = true
				  },1000)
                }
              }
            });
        } else {
          this.$message.warning(res.message);
        }
      });
	  
	  
	  var attrFlag = true //控制添加属性只能点一次
	  
	  if ($('body', parent.document).find("#maskClass").length > 0) {
	  	$('body', parent.document).find("#maskClass").remove();
	  }
	  
	  const me = this
	  // 点击添加属性按钮
	  $('#addAttribute').on('click', () => {
	  	localStorage.setItem('VUE_APP_UEDITOR_URI',process.env.VUE_APP_UEDITOR_URI)
	  	// var imgattr = $('.attr-table .file-input')
	  	// me.imgArr = []
	  	// for (var j = 0; j < imgattr.length; j++) {
	  	// 	me.strArr[j].img = $(imgattr).eq(j).val()
	  	// }
	  	
	  	// me.imgArr = JSON.parse(JSON.stringify(me.strArr))
	  	
	  	// me.imgArr.filter(items=>{
	  		
	  	// 	items.attrStr = ''
	  		
	  	// 	items.attr_list.filter(item=>{
	  			
	  	// 		items.attrStr += ',' + item.attr_name
	  			
	  	// 	})
	  		
	  	// 	items.attrStr = items.attrStr.replace(',','')
	  		
	  	// })
	  	
	  	if (attrFlag) {
	  		var price1 = me.price_cbj //经销商价
	  		var price2 = me.price_yj //原价
	  		var price3 = me.price_sj //终端价
	  		var size = me.unit //单位
	  		var kucun = me.kucun //库存
	  		
	  		if (!(price1 && price2 && price3 && size != 0 && kucun)) {
	  			me.$message.warning("商品属性不能为空！");
	  			attrFlag = true
	  			return
	  		}
	  		
	  		if ($('body', parent.document).find("#maskClass").length > 0) {
	  			$('body', parent.document).find("#maskClass").css('display', '')
				
				$('body', parent.document).find(".maskNew iframe")[0].contentWindow.app.filterText = ''
				$('body', parent.document).find(".maskNew iframe")[0].contentWindow.app.loadFlag = false
	  		} else {
	  			var str =
	  				`
	  				<div class="maskNew" id="maskClass" style="z-index: 9999;">
	  					<div style="width:724px;height:540px;background:rgba(255,255,255,1);border-radius:4px;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);">
	  						<div style="display: flex;justify-content: space-between;align-items: center;height: 60px;box-sizing: border-box;padding-left: 20px;color: #414658;font-weight: bold;font-size: 16px;border-bottom: 2px solid #E9ECEF;">
	  							设置属性
	  							<a class="maskClose" href="javascript:void(0);" style="padding: 20px;"><img src="gb.png"/></a>
	  						</div>
	  
	  						<iframe scrolling="yes" frameborder="0" src="Choose.html" style="width: 100%;height: 410px"></iframe>
	  
	  						<div style="height: 70px;box-sizing: border-box;border-top: 1px solid #E9ECEF;display: flex;align-items: center;justify-content: flex-end;">
	  							<a class="maskClose" href="javascript:;" style="width:112px; height:36px; border:1px solid rgba(40,144,255,1); border-radius:2px;display: flex;align-items: center;justify-content: center;color: #2890FF;margin-right: 10px;box-sizing: border-box;background-color: #FFFFFF;">取消</a>
	  							<a id="maskSave" href="javascript:;" style="width:112px;height:36px;background:rgba(40,144,255,1);border-radius:2px;display: flex;align-items: center;justify-content: center;color: #FEFEFE;margin-right: 20px;">确定</a>
	  						</div>
	  
	  
	  					</div>
	  				</div>
	  			`
	  			$('body', parent.document).append(str)
	  		}
	  		
	  		
	  		$('body', parent.document).find('#maskSave').unbind().bind('click', function() {
	  			let checkAll = $('body', parent.document).find(".maskNew iframe")[0].contentWindow.app.checkAll
				
				me.strArr1 = JSON.stringify(checkAll)
				
	  			// classDivAppend()
	  			let attrTitle = []
	  			// me.attrTitle
	  			
	  			if(checkAll.length == 0){
	  				me.$message.warning('请选择商品属性')
	  				return
	  			}
	  			
	  			checkAll.filter(items=>{
	  				
	  				if(attrTitle.length == 0){
	  					let obj = {
	  						attr_group_name: items.name0,
	  						attr_list: [
	  							{
	  								attr_name: items.name1,
	  								chooseMe: true,
	  							}
	  						],
	  						isShow: false
	  					}
	  					attrTitle.push(obj)
	  				}else{
	  					let index = attrTitle.findIndex((item)=>{
	  						return item.attr_group_name == items.name0
	  					})
	  					
	  					if(index<0){
	  						let obj = {
	  							attr_group_name: items.name0,
	  							attr_list: [
	  								{
	  									attr_name: items.name1,
	  									chooseMe: true,
	  								}
	  							],
	  							isShow: false
	  						}
	  						attrTitle.push(obj)
	  					}else{
	  						attrTitle[index].attr_list.push({
	  							attr_name: items.name1,
	  							chooseMe: true,
	  						})
	  					}
	  				}
	  				
	  				
	  			})
	  			
	  			me.attrTitle = attrTitle
	  			var strArr = []
	  			console.log(attrTitle)
	  			var listX = 0
	  			for (var i = 0; i < attrTitle.length; i++) {
	  				var attr_list = attrTitle[i].attr_list
	  				if (listX == 0) {
	  					listX = attr_list.length
	  				} else {
	  					listX = attr_list.length > 0 ? (attr_list.length * listX) : listX
	  				}
	  			}
	  			
	  			for (var i = 0; i < listX; i++) {
	  				if (me.strArr[i]) {
	  					strArr.push({
	  						"cbj": price1,
	  						"yj": price2,
	  						"sj": price3,
	  						"unit": size,
	  						"kucun": kucun,
	  						"image": '', //图片
	  						"bar_code": '', // 条形码
	  						"attr_list": [],
	  						"cid": me.strArr[i].cid
	  					})
	  				} else {
	  					strArr.push({
	  						"cbj": price1,
	  						"yj": price2,
	  						"sj": price3,
	  						"unit": size,
	  						"kucun": kucun,
	  						"image": '', //图片
	  						"bar_code": '', // 条形码
	  						"attr_list": [],
	  						"cid": ''
	  					})
	  				}
	  			}
	  			
	  			var th_title = JSON.parse(JSON.stringify(attrTitle))
	  			
	  			digui(th_title, 0, listX)
	  			
	  			strArr.filter(items=>{
	  				
	  				var attrStr = ''
	  				var attrStr1 = ''
	  				
	  				items.attr_list.filter(item=>{
	  					
	  					attrStr += ',' + item.attr_name
	  					
	  				})
	  				
	  				let attr_list = items.attr_list.reverse()
	  				
	  				attr_list.filter(item=>{
	  					
	  					attrStr1 += ',' + item.attr_name
	  					
	  				})
	  				
	  				
	  				attrStr = attrStr.replace(',','')
	  				attrStr1 = attrStr1.replace(',','')
	  				
	  				// me.imgArr.filter(its=>{
	  				// 	if(its.attrStr == attrStr){
	  				// 		items.img = its.img
	  				// 	}
	  				// })
	  				
	  			})
	  			
	  			me.attrTitle = []
	  			
	  			setTimeout(function(){
	  				me.attrTitle = JSON.parse(JSON.stringify(th_title))
	  				me.strArr = JSON.parse(JSON.stringify(strArr))
	  				me.tableList = JSON.parse(JSON.stringify(strArr))
	  				
	  				var column = []
	  				th_title.filter(item=>{
	  				  var name = item.attr_group_name
	  				  column.push(
	  				    {
	  				      title: name,
	  				      dataIndex: name,
	  				      key: name,
	  				    }
	  				  )
	  				})
	  				column.push(...columns)
	  				me.columns = column
	  				
	  				var tableData = []
	  				strArr.filter(item=>{
	  				  var arr = JSON.parse(JSON.stringify(item))
	  				  delete arr['attr_list']
	  				  item.attr_list.filter(items=>{
	  				    arr[items.attr_group_name] = items.attr_name
	  				  })
	  				  tableData.push(arr)
	  				})
	  				
	  				tableData.filter((item,index)=>{
	  				  if((index+1)%10==0){
	  				    item.pages = (index+1)/10
	  				  }else{
	  				    item.pages = parseInt((index+1)/10)+1
	  				  }
	  				
	  				})
	  				
	  				me.tableData = JSON.parse(JSON.stringify(tableData))
	  			},5)
	  			
	  			function digui(th_title, i, _listX) {
	  				// 如果该循环的子项没有东西则停止递归
	  				if (!th_title[i]) {
	  					if (i < (th_title.length - 1)) {
	  						th_title.splice(i, 1)
	  						digui(th_title, i, _listX)
	  						return
	  					}
	  					return
	  				}
	  			
	  				// 如果该项属性的没有属性值，则删除该项重新递归
	  				if (th_title[i].attr_list.length == 0) {
	  					th_title.splice(i, 1)
	  					digui(th_title, i, _listX)
	  					return
	  				}
	  			
	  				var xx = 0
	  				if (i == 0) {
	  					// 第一个规格属性的格式是白色白色白色,黑色黑色黑色
	  					for (var j = 0; j < th_title[i].attr_list.length; j++) {
	  						var value = th_title[i].attr_list[j].attr_name
	  						for (var x = 0; x < listX / th_title[i].attr_list.length; x++) {
	  							var name = th_title[i].attr_group_name
	  							strArr[xx].attr_list.push({
	  								'attr_id': '',
	  								'attr_name': value,
	  								'attr_group_name': name
	  							})
	  							xx++
	  						}
	  					}
	  				} else if (i < th_title.length - 1) {
	  			
	  					_listX = Math.round(_listX / th_title[i - 1].attr_list.length)
	  					// 外面这层循环代表当前属性在内循环完成之后进入新的循环,比如白色白色黑色黑色红色红色,完成之后再次白色白色黑色黑色红色红色循环,总行数除以前一个属性每个属性有多少行,得出总循环数
	  					for (var l = 0; l < listX / _listX; l++) {
	  						for (var j = 0; j < th_title[i].attr_list.length; j++) {
	  							var value = th_title[i].attr_list[j].attr_name
	  							// 当前规格的前一个每个属性行数,除当前
	  							for (var x = 0; x < _listX / th_title[i].attr_list.length; x++) {
	  								var name = th_title[i].attr_group_name
	  								strArr[xx].attr_list.push({
	  									'attr_id': '',
	  									'attr_name': value,
	  									'attr_group_name': name
	  								})
	  								xx++
	  							}
	  						}
	  					}
	  			
	  				} else {
	  					// 后面的规格属性格式是x,l,xl x,l,xl循环
	  					for (var x = 0; x < listX / th_title[i].attr_list.length; x++) {
	  						for (var j = 0; j < th_title[i].attr_list.length; j++) {
	  							var value = th_title[i].attr_list[j].attr_name
	  							var name = th_title[i].attr_group_name
	  							strArr[xx].attr_list.push({
	  								'attr_id': '',
	  								'attr_name': value,
	  								'attr_group_name': name
	  							})
	  							xx++
	  						}
	  					}
	  				}
	  				i++
	  				if (i < th_title.length) {
	  					digui(th_title, i, _listX)
	  				}
	  			}
	  			
	  			
	  			$('body', parent.document).find("#maskClass").css('display', 'none')
	  		})
	  		
	  		$('body', parent.document).find('.maskClose').unbind().bind('click', function() {
	  			$('body', parent.document).find("#maskClass").remove()
	  		})
	  	}
	  })
  },
  watch: {
    visible(val) {
      if (val) {
        var flag =
          this.price_cbj &&
          this.price_yj &&
          this.price_sj &&
          this.kucun &&
          this.unit;
        if (!flag) {
          this.$message.warning("请填写商品属性！");
          this.visible = false;
        }
      }
    },
    visibleB(val) {
      if (val) {
        var flag =
          this.price_cbj &&
          this.price_yj &&
          this.price_sj &&
          this.kucun &&
          this.unit;
        if (!flag) {
          this.$message.warning("请填写商品属性！");
          this.visibleB = false;
        }
      }
    },
	price_cbj(val){
		if(this.tableData.length>0 && this.watchFlag){
			this.tableData.filter(item=>{
				item.cbj = val
			})
		}
	},
	price_sj(val){
		if(this.tableData.length>0 && this.watchFlag){
			this.tableData.filter(item=>{
				item.sj = val
			})
		}
	},
	price_yj(val){
		if(this.tableData.length>0 && this.watchFlag){
			this.tableData.filter(item=>{
				item.yj = val
			})
		}
	},
	kucun(val){
		if(this.tableData.length>0 && this.watchFlag){
			this.tableData.filter(item=>{
				item.kucun = val
			})
		}
	},
	unit(val){
		if(this.tableData.length>0 && this.watchFlag){
			this.tableData.filter(item=>{
				item.unit = val
			})
		}
	}
  },
  methods: {
    handleAct(){
      if(this.act_type == 6){
        this.dp_show = false
      }else {
        this.dp_show = true
      }
    },
    async httpGetClass(data = { cid: 1 }){
      await this.$request
              .get("?module=pc_api&action=product&app=choice_class", { params: data })
              .then(res => {
                let { code, message, list } = res;
                if (code === 200) {

                  let { class_list, brand_list, class_id} = list

                  this.options.forEach(item => {
                    if(item.cid == data.cid){

                      if(!item.children){

                        if(class_list.length){

                          let result = Array.from(class_list[0],items => {
                            items.isLeaf = false
                            return items
                          })

                          console.log(result)

                          item.children = [
                            ...result
                          ]
                        }
                      }

                    }
                  })

                } else {
                  this.$message.error(message);
                }
              });
    },
    onCloses(index){
      this.tableList[index].image = ''
    },
    /**
     * @name 商品分类
     */
    getCommodityClass(data = { class_str: 0, brand_str: "" }) {
      this.$request
        .get("?module=pc_api&action=product&app=get_class", { params: data })
        .then(res => {
          let { code, message, list } = res;
          if (code === 200) {
            let result = Array.from(list.class_list[0], item => {
              item.isLeaf = false;
              return item;
            });

            Object.assign(this, {
              // brandlist: list.brand_list,
              options: result
            });
          } else {
            this.$message.error(message);
          }
        });
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;

      function callback(list){
        
        let { class_list, brand_list, class_id} = list

        if(class_id){
          targetOption.isLeaf = true
          targetOption.loading = false
        }

        targetOption.loading = false

        if(class_list.length){

          let result = Array.from(class_list[0],item => {
            item.isLeaf = false
            return item
          })

          targetOption.children = [
            ...result
          ]
        }

        this.cache[targetOption.cid] = brand_list

        Object.assign(this,{
          options: [...this.options],
          brandlist: brand_list
        })

      }


      this.loadClass({ cid: targetOption.cid }, callback);
    },
    loadData2(cid) {
      
      function callback() {

      }
      
      this.loadClass({ cid: cid }, callback);
    },
    /**
     * @name 分类加载
     * */

    loadClass(data = { cid: 1, brand_str: "" }, callback) {
      console.log(data);
      this.$request
        .get("?module=pc_api&action=product&app=choice_class", { params: data })
        .then(res => {
          let { code, message, list } = res;
          if (code === 200) {
            callback.call(this, list);
          } else {
            this.$message.error(message);
          }
        });
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    /**
     * @name 保存
     * */
    onSave() {
      var product_title = this.pro_title;
      var subtitle = this.pro_title1;
      var keyword = this.pro_keys;
      var weight = this.weight;
      var product_number = this.product_number;
      var product_class_id = this.pro_class;
      var brand_id = this.pro_brand ? this.pro_brand : "";
      var imgurls = this.imgurls;
      var cover_map = this.cover_map
      var initial = `cbj=${this.price_cbj},yj=${this.price_yj},sj=${this.price_sj},kucun=${this.kucun},unit=${this.unit},stockWarn=${this.warning}`;
      var stockWarn = this.warning;
	  
	  
	  var tableList = JSON.parse(JSON.stringify(this.tableList))
	  if(this.tableData&&this.tableData.length>0){
		  this.tableData.filter((item,index)=>{
			  tableList[index].cbj = item.cbj
			  tableList[index].yj = item.yj
			  tableList[index].sj = item.sj
			  tableList[index].kucun = item.kucun
			  tableList[index].bar_code = item.bar_code
		  })
	  }

      var attr_group = JSON.stringify(this.attrTitle);

      var attr_arr = JSON.stringify(tableList);

      var freight_id = this.freight;
      var s_type = [];

      // this.form.validateFields(err => {
      //   if (!err) {
      //     console.info('success');
      //   }
      // });

      // this.setTag.filter((item, index) => {
      //   if (item) {
      //     s_type.push(index+1);
      //   }
      // });
      this.s_type.filter((items,indexs)=>{
        this.setTag.filter((item,index)=>{
          if(indexs==index && item){
            s_type.push(items.value)
          }
        })
      })

      var active = this.act_type;

      // return
      var display_position = [];

      // this.display_position.filter((item, index) => {
      //   if (item) {
      //     display_position.push(index);
      //   }
      // });

      this.show_adr.filter((items,indexs)=>{
        this.display_position.filter((item,index)=>{
          if(indexs == index && item){
            display_position.push(items.value)
          }
        })
      })

      var is_hexiao = this.is_offline == "是" ? 1 : 0;

      var content = this.$refs.ue.getContent();
	  
      if(!(this.pro_title&&this.pro_keys&&this.price_cbj&&this.price_yj&&this.price_sj&&this.kucun&&this.warning&&this.freight&&this.pro_brand&&this.pro_class)){
        this.$message.warning('请先完善以上的信息！')
        return
      }
	  
	  if(this.price_cbj<0){
	  		  this.$message.warning('经销商价不能为负数！')
	  		  return
	  }
	  
	  if(this.price_yj<0){
	  		this.$message.warning('原价不能为负数！')
	  		return
	  }
	  
	  if(this.price_sj<0){
	  		this.$message.warning('终端价不能为负数！')
	  		return
	  }
	  
	  if(this.kucun<0){
	  		  this.$message.warning('库存不能为负数！')
	  		  return
	  }
	  
	  if(this.warning<0){
	  		  this.$message.warning('库存预警不能为负数！')
	  		  return
	  }
	  
	  let warnFlag = this.tableData.some(item=>{
	  		  return Number(item.cbj)<0 || Number(item.yj)<0 || Number(item.sj)<0 || Number(item.kucun)<0
	  })
	  if(warnFlag){
	  		  this.$message.warning('商品价格及库存等规格不能为负数！')
	  		  return
	  }

      if (!cover_map) {
        this.$message.warning('封面图片不能为空！')
        return
      }
	  
	  
	  imgurls.filter((item,index)=>{
		  if(typeof item == "string"){
			  
			  imgurls[index] = {
				  "product_url": item,
				  "is_center": 0
			  }
		  }
	  })
	  
	  imgurls[0].is_center = 1
	  
      var data = {
        display_position: display_position.join(","),
        s_type: s_type,
        weightSize: this.weight_unit,
        product_title,
        subtitle,
        keyword,
        weight,
        product_number,
        product_class_id,
        brand_id,
        initial,
        attr_group,
        attr_arr,
        imgurls,
        cover_map,
        freight_id,
        active,
		volume:this.volume,
        is_hexiao,
        content,
        stockWarn,
        id: this.pro_id,
		isVirtual: this.commodity_type,
      };
      this.$request
        .post("?module=pc_api&action=product&app=re_edit", data)
        .then(res => {
          if (res.code == 200) {
            this.$message.success(res.message);
            // this.$router.go(-1);
            this.$router.push('/goodsmanage?tab='+this.activekey)
          } else {
            this.$message.warning(res.message || res.status);
          }
        });
    },
    /**
     * @name 返回
     * */

    onGoBack() {
      // this.$router.go(-1);
      this.$router.push('/goodsmanage?tab='+this.activekey)
    },
    /**
     * @name 设置主图
     * */

    setMap(index) {
      var img = this.imgurls[index];
      this.imgurls.splice(index, 1);
      this.imgurls.unshift(img);

      var item = this.fileList[index];
      this.fileList.splice(index, 1);
      this.fileList.unshift(item);
    },
    /**
     * @name 上传商品属性图
     * */

    changeAttrImg(file, record, index) {
      if (file.file.status == "removed") {
        this.tableList[index].image = "";
      } else if (file.file.status == "done") {
        this.tableList[index].image = file.fileList[0].response.url;
      }
    },
    onChange(value) {
      // if(!value.length){
      //   this.brandlist = []
      //   this.brand_id  = undefined
      // }
      this.form.setFieldsValue({
        'pro_brand' : undefined
      })
      this.brandlist = this.cache[value[value.length - 1]]

      this.pro_class = value[value.length - 1];
    },
    handleSelectChange(value) {
      console.log(`selected ${value}`);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    /**
     * @name 上传商品封面图
     * */
    handleChange2({file,fileList}) {
      this.fileList2 = fileList
      console.log(file);

      if(file.status == 'done'){
        this.cover_map = file.response.url
      }else if(file.status == 'removed'){
        this.cover_map = '';
      }
    },
    /**
     * @name 上传商品展示图
     * */

    handleChange({ file, fileList }) {
      this.fileList = fileList;
	  
      if (file.status == "done") {
        this.imgurls.push(file.response.url);
      } else if (file.status == "removed") {
        var index = this.imgurls.findIndex(item => {
			if(file.response){
				return item == file.response.url;
			}else{
				return item == file.url;
			}
        });
        this.imgurls.splice(index, 1);
      }
    },
    /**
     * @name 选择商品规格属性名称
     */
    handleChangeValue(value) {
      this.chooseAttrOption = value;
      this.attrList.filter(item => {
        item.status = false;
        value.filter(items => {
          if (item.name == items) {
            item.status = true;
          }
        });
      });
    },
    /**
     * @name 删除商品规格属性名称
     */
    delChooseName(item) {
      item.status = false;
      var index = this.chooseAttrOption.findIndex(items => {
        return items == item.name;
      });
      this.chooseAttrOption.splice(index, 1);
    },
    /**
     * @name 选择商品规格属性值
     */
    chooseChange(e, item) {
      item.status = e.target.checked;
    },
    /**
     * @name 选择商品规格点击确定，计算表格数据
     */
    chooseAttrOk() {
      var attrTitle = [];
      this.attrList.filter(item => {
        if (item.status) {
          attrTitle.push({
            attr_group_name: item.name,
            attr_list: [],
            isShow: false
          });
          item.children.filter(items => {
            if (items.status) {
              attrTitle[attrTitle.length - 1].attr_list.push({
                attr_name: items.name,
                chooseMe: true
              });
            }
          });

          if (attrTitle[attrTitle.length - 1].attr_list.length == 0) {
            attrTitle.splice(attrTitle.length - 1, 1);
          }
        }
      });

      if (attrTitle.length == 0) {
        this.$message.warning("请选择商品属性！");
        return;
      }

      //计算表格总共多少行
      var listX = 0;
      for (var i = 0; i < attrTitle.length; i++) {
        var attr_list = attrTitle[i].attr_list;
        if (listX == 0) {
          listX = attr_list.length;
        } else {
          listX = attr_list.length > 0 ? attr_list.length * listX : listX;
        }
      }

      var tableList = [];
      for (var i = 0; i < listX; i++) {
        tableList.push({
          cbj: this.price_cbj,
          yj: this.price_yj,
          sj: this.price_sj,
          unit: this.unit,
          kucun: this.kucun,
          image: "", //图片
          bar_code: "", // 条形码
          attr_list: [],
          cid: ""
        });
      }

      if (this.isHidel) {
        for (let i in this.tableList) {
          tableList[i].cid = this.tableList[i].cid;
          tableList[i].image = this.tableList[i].img;
        }
        this.isHidel = false;
      }

      this.tableCompute(attrTitle, 0, listX, listX, tableList);
      this.visible = false;
    },
    /**
     * @name 自定义商品规格添加属性
     */
    addNature() {
      if (this.addAttrName == "") {
        this.$message.warning("属性名为空！");
        return;
      }
      var name = this.addAttrName;
      var flag = this.attrAdd.findIndex(item => {
        return item.attr_group_name == name;
      });
      if (flag >= 0) {
        this.$message.warning("属性名重复！");
        return;
      }
      this.addAttrName = "";
      this.attrAdd.push({
        attr_group_name: name,
        attrValue: "",
        attr_list: [],
        isShow: false
      });
    },
    /**
     * @name 自定义商品规格删除属性名
     */
    delAttrName(index) {
      this.attrAdd.splice(index, 1);
    },
    /**
     * @name 自定义商品规格添加属性值
     */
    addNatureVal(item) {
      if (item.attrValue == "") {
        this.$message.warning("属性值为空！");
        return;
      }
      var name = item.attrValue;
      item.attrValue = "";
      var flag = item.attr_list.findIndex(items => {
        return items.attr_name == name;
      });
      if (flag >= 0) {
        this.$message.warning("属性值重复！");
        return;
      }
      item.attr_list.push({
        attr_name: name,
        chooseMe: true
      });
    },
    /**
     * @name 自定义商品规格删除属性值
     */
    delAttrValue(index, indx) {
      this.attrAdd[index].attr_list.splice(indx, 1);
    },
    /**
     * @name 自定义商品规格点击确定，计算表格数据
     */
    addAttrOk() {
      var attrTitle = JSON.parse(JSON.stringify(this.attrAdd));

      // 循环删除没有属性值的属性名
      var iw = 0;
      while (iw < attrTitle.length) {
        if (attrTitle[iw].attr_list.length == 0) {
          attrTitle.splice(iw, 1);
        } else {
          iw++;
        }
      }

      if (attrTitle.length == 0) {
        this.$message.warning("请添加商品属性！");
        return;
      }

      //计算表格总共多少行
      var listX = 0;
      for (var i = 0; i < attrTitle.length; i++) {
        var attr_list = attrTitle[i].attr_list;
        if (listX == 0) {
          listX = attr_list.length;
        } else {
          listX = attr_list.length > 0 ? attr_list.length * listX : listX;
        }
      }

      var List = [];
      for (var i = 0; i < listX; i++) {
        List.push({
          cbj: this.price_cbj,
          yj: this.price_yj,
          sj: this.price_sj,
          unit: this.unit,
          kucun: this.kucun,
          image: "", //图片
          bar_code: "", // 条形码
          attr_list: [],
          cid: ""
        });
      }

      this.tableCompute(attrTitle, 0, listX, listX, List);
      this.visibleB = false;
    },
    // 属性表格计算
    tableCompute(th_title, i, listX, _listX, tableList) {
      // 如果该循环的子项没有东西则停止递归
      if (!th_title[i]) {
        if (i < th_title.length - 1) {
          th_title.splice(i, 1);
          this.tableCompute(th_title, i, listX, _listX, tableList);
          return;
        }
        return;
      }

      // 如果该项属性的没有属性值，则删除该项重新递归
      if (th_title[i].attr_list.length == 0) {
        th_title.splice(i, 1);
        this.tableCompute(th_title, i, listX, _listX, tableList);
        return;
      }

      var xx = 0;
      if (i == 0) {
        // 第一个规格属性的格式是白色白色白色,黑色黑色黑色
        for (var j = 0; j < th_title[i].attr_list.length; j++) {
          var value = th_title[i].attr_list[j].attr_name;
          for (var x = 0; x < listX / th_title[i].attr_list.length; x++) {
            var name = th_title[i].attr_group_name;
            tableList[xx].attr_list.push({
              attr_id: "",
              attr_name: value,
              attr_group_name: name
            });
            xx++;
          }
        }
      } else if (i < th_title.length - 1) {
        _listX = Math.round(_listX / th_title[i - 1].attr_list.length);
        // 外面这层循环代表当前属性在内循环完成之后进入新的循环,比如白色白色黑色黑色红色红色,完成之后再次白色白色黑色黑色红色红色循环,总行数除以前一个属性每个属性有多少行,得出总循环数
        for (var l = 0; l < listX / _listX; l++) {
          for (var j = 0; j < th_title[i].attr_list.length; j++) {
            var value = th_title[i].attr_list[j].attr_name;
            // 当前规格的前一个每个属性行数,除当前
            for (var x = 0; x < _listX / th_title[i].attr_list.length; x++) {
              var name = th_title[i].attr_group_name;
              tableList[xx].attr_list.push({
                attr_id: "",
                attr_name: value,
                attr_group_name: name
              });
              xx++;
            }
          }
        }
      } else {
        // 后面的规格属性格式是x,l,xl x,l,xl循环
        for (var x = 0; x < listX / th_title[i].attr_list.length; x++) {
          for (var j = 0; j < th_title[i].attr_list.length; j++) {
            var value = th_title[i].attr_list[j].attr_name;
            var name = th_title[i].attr_group_name;

            tableList[xx].attr_list.push({
              attr_id: "",
              attr_name: value,
              attr_group_name: name
            });

            xx++;
          }
        }
      }
      i++;
      if (i < th_title.length) {
        this.tableCompute(th_title, i, listX, _listX, tableList);
      } else {
        this.attrTitle = JSON.parse(JSON.stringify(th_title));
        this.tableList = JSON.parse(JSON.stringify(tableList));

        var column = [];
        th_title.filter(item => {
          var name = item.attr_group_name;
          column.push({
            title: name,
            dataIndex: name,
            key: name
          });
        });
        column.push(...columns);
        this.columns = column;

        var tableData = [];

        tableList.filter(item => {
          var arr = JSON.parse(JSON.stringify(item));
          delete arr["attr_list"];
          item.attr_list.filter(items => {
            arr[items.attr_group_name] = items.attr_name;
          });

          tableData.push(arr);
        });
		
		tableData.filter((item,index)=>{
			item.ind = index
		})

        this.tableData = JSON.parse(JSON.stringify(tableData));
      }
    },
    // 删除表格行
    onDelele(index) {
      this.tableData.splice(index, 1);
      this.tableList.splice(index, 1);
    }
  },
  components: {
    UEditor
  }
};
</script>

<style lang="less" >
.ant-card-wider-padding .ant-card-head{
		padding: 0 20px;
	}
.modals {
  .ant-form-item {
    margin-bottom: 0px;
  }

  .boxs {
    display: flex;
    height: 36px;
    min-height: 36px;
    padding-top: 0px;
    align-items: center;
    width: 410px;
    justify-content: space-between;
  }

}
.goods-add {
	overflow-x: hidden;
  height: 100%;
  overflow-y: auto;
  .foot {
    height: 68px;
    width: 100%;
    border-top: 1px solid #e9ecef;
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 20px;
    background: #ffffff;
    z-index: 999;

    .btns {
      margin-right: 10px;
    }
  }

  .ant-card-head {
    position: sticky !important;
    top: 0 !important;
    background: #ffff !important;
    z-index: 991 !important;
  }
}

.boxs {
  padding: 20px 0 12px;
  min-height: 100px;
}

.clearfix{
  position: relative;
  // width: 600px;
}
.setMap0,.setMap1,.setMap2,.setMap3,.setMap4{
  position: absolute;bottom: 8px;height: 20px;font-size: 12px;line-height: 20px;text-align: center;width: 104px;background: rgba(0,0,0,0.6);color: #ffffff;z-index: 99;
  cursor: pointer;
}
.setMap0{
  left: 0;background: #2890FF;width: 32px;
}
.setMap1{left: 112px;}
.setMap2{left: 224px;}
.setMap3{left: 336px;}
.setMap4{left: 448px;}

.edui-default .edui-editor{
	z-index: 990!important;
}

.imgssds {
  position: relative;
}

.imgssds .close{
  position: absolute;
  top: 0;
  right: 0;
}
</style>